function reservationsQueueUrl() {
  return '/api/reservations';
}

function decisionUrl(vehicleSlug, reservationId) {
  return `/api/vehicles/${encodeURIComponent(vehicleSlug)}/reservations/${encodeURIComponent(reservationId)}`;
}

async function fetchPendingReservations() {
  const response = await fetch(reservationsQueueUrl());

  if (!response.ok) {
    throw new Error(`Could not load reservations (${response.status})`);
  }

  const body = await response.json();
  return body.reservations || [];
}

async function decideReservation(vehicleSlug, reservationId, decision) {
  const response = await fetch(decisionUrl(vehicleSlug, reservationId), {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ decision }),
  });

  const body = await response.json().catch(() => ({}));

  if (response.ok) {
    return { outcome: decision };
  }

  return { outcome: 'error', error: body.error || 'Something went wrong. Please try again.' };
}

export { fetchPendingReservations, decideReservation };
